<template>
  <section
    class="course-module"
    :class="{ 'course-module--modules-collapsed' : isCourseModuleActive }"
  >
    <div
      class="course-module__header"
      @click="toggleCourseModuleTab"
    >
      <h3
        v-if="course.is_express"
        class="course-module__header__title"
      >
        <span><FlashSVG /> <strong>Workshop</strong></span>
      </h3>

      <h3
        v-else
        class="course-module__header__title"
      >
        <span class="course-module__header__title-legend">Módulo {{ index }}</span>
        <span clsas="course-module__header__title-name">{{ courseModule.name }}</span>
      </h3>

      <span class="course-module__toggle-arrow">
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 12 9"><g fill="none" fill-rule="evenodd" opacity=".497"><path d="M-6-7h24v24H-6z" stroke="#000" stroke-opacity=".012" stroke-width="0"></path> <path fill="#000" d="M1.41.84L6 5.42 10.59.84 12 2.25l-6 6-6-6z"></path></g></svg>
      </span>
    </div>

    <CourseModuleClassesNav 
      v-if="isCourseModuleActive"
      :course-classes="courseModuleClasses(courseModule)"
    />
  </section>
</template>

<script>
  import { mapMutations, mapGetters } from 'vuex'
  import FlashSVG from '@/components/svg/FlashSVG'
  import CourseModuleClassesNav from '@/components/course/course-class/CourseModuleClassesNav'

  export default {
    components: {
      FlashSVG,
      CourseModuleClassesNav,
    },

    props: {
      index: { type: Number, default: 1 },
      courseModule: { type: Object, default: () => ({}) }
    },

    computed: {
      ...mapGetters('course', [
        'course',
        'hasCourseAccess',
        'courseModuleClasses',
        'courseModuleTabActive'
      ]),

      isCourseModuleActive () {
        return this.courseModuleTabActive === null || (this.courseModuleTabActive == this.courseModule.id)
      }
    },

    methods: {
      ...mapMutations('course', [
        'setCourseModuleClass',
        'setCourseModuleTabActive'
      ]),

      toggleCourseModuleTab () {
        if (this.isCourseModuleActive) {
          this.setCourseModuleTabActive(false)
        } else {
          this.setCourseModuleTabActive(this.courseModule.id)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .course-module {
    $p: &;

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #ededed;
      border-radius: 5px;
      padding: 10px 15px;
      border-bottom: 2px solid darken(#ededed, 5%);
      margin-bottom: 10px;
      cursor: pointer;
      user-select: none;


      &__title {
        display: flex;
        align-items: center;
        font-family: 'Poppins';
        font-size: 14px;
        padding-right: 10px;

        &-legend {
          font-size: 13px;
          flex: 0 0 90px;
          font-weight: 700;
          text-transform: uppercase;
          color: lighten(#000, 25%);
        }

        svg {
          width: 20px;
        }
      }

      &:hover #{$p}__toggle-arrow {
        background: lighten(#000, 85%);
      }
    }

    &__toggle-arrow {
      background-color: transparent;
      border-radius: 5px;
      padding: 0 8px;
      transition: background-color .5s ease;
    }

    &--modules-collapsed #{$p}__toggle-arrow {
      transform: rotate(180deg);
    }

    &__courses-list {
      position: relative;

      &__item:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }
</style>